function getPanoVideoUrl({
  cdnDomain,
  url,
}: {
  cdnDomain: number;
  url: string;
}) {
  return `https://ssl-video${cdnDomain}.720static.com/${url}`;
}

export default getPanoVideoUrl;
